import { SelectStyled } from '@molecules/Filters/styles';
import { Box, InputLabel, styled } from '@mui/material';
import { theme } from '@styles';

export const StyledWrapperSelectBox = styled(Box)`
  display: flex;
  align-items: center;
  width: fit-content;
`;

export const StyledInputLabel = styled(InputLabel)`
  margin-bottom: 0;
  width: fit-content;
  margin-right: 12px;

  ${theme.breakpoints.down('xl')} {
    font-size: 14px;
  }
`;

export const StyledSelect = styled(SelectStyled)`
  width: 220px;
  height: 48px;
`;
